module.exports = __webpack_public_path__ + "img/JuChain.fd006ef0.png";